import React from "react";
import { Reveal, SectionLabel } from "./motion";
import { useLang } from "@/LanguageContext";

export default function Values() {
  const { t } = useLang();
  return (
    <section id="values" data-testid="values-section" className="relative py-24 lg:py-32 bg-surface">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="max-w-3xl">
          <Reveal><SectionLabel>{t.values.eyebrow}</SectionLabel></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-white mt-6 tracking-[-0.01em]">{t.values.title}</h2>
          </Reveal>
        </div>
        <div className="mt-16 grid md:grid-cols-3 gap-10 lg:gap-16">
          {t.values.items.map((v, i) => (
            <Reveal key={v.n} delay={i * 0.1} y={40}>
              <div className="border-t border-white/10 pt-8">
                <span className="font-serif text-6xl lg:text-7xl text-outline block leading-none">{v.n}</span>
                <h3 className="font-serif text-2xl text-gold mt-6">{v.title}</h3>
                <p className="text-white/60 leading-relaxed mt-4">{v.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
